import * as React from 'react';

import { cn } from '@/lib/utils';

const Input = React.forwardRef(({ className, type, ...props }, ref) => (
  <input
    type={type}
    className={cn(
      'flex h-10 w-full border-2 border-[#1a1a1a] bg-[#fefcf6] px-3 py-2 text-base text-[#1a1a1a] placeholder:text-[#8a7e6b] focus-visible:outline-none focus-visible:border-[#d62828] focus-visible:shadow-[3px_3px_0px_#d62828] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium',
      className
    )}
    style={{ fontFamily: "'Patrick Hand', cursive" }}
    ref={ref}
    {...props}
  />
));
Input.displayName = 'Input';

export { Input };
export default Input;
